import React from 'react';
import { useDispatch } from "react-redux";
import { setDashBoardIsActive } from "../../Features/Misc/activeSlice";
import { setWatchIsActive } from "../../Features/Misc/navBarSlice";

import { Link } from "react-router-dom";

const ExploreEverythingButton = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setWatchIsActive());
        dispatch(setDashBoardIsActive());
    };

    return (
        <button
            onClick={handleClick}
            className="
                    flex
                    justify-center
                    items-center
                    text-white
                    bg-gold-accent
                    rounded-lg
                    py-3
                    px-4
                    sm:px-14

                    lg:px-18

                    lg:text-lg

                    font-medium
                    cursor-pointer
                     hover:opacity-60 transition-opacity duration-300 transition-background-color
                    "
        >
            Explore everything
            <i className="ri-arrow-right-line ml-3 sm:ml-6"></i>
        </button>

    );
};

export default ExploreEverythingButton;